import React from 'react';

function Error() {
	return (
		<div className='error'>
			<h1 className='text60'>Page not found</h1>
		</div>
		)
}

export default Error;